export function BrandLogo({ portal = "管理后台", inverse = false, wordmark = false }: { portal?: string; inverse?: boolean; wordmark?: boolean }) {
  return <span className={`brand-logo${inverse ? " brand-logo--inverse" : ""}`} role="img" aria-label={`乐学 Welearn ${portal}`}>
    <img className={wordmark ? "brand-logo__wordmark" : undefined} src={wordmark ? "/brand/welearn-wordmark-v2.webp" : "/brand/welearn-mark-v2.webp"} alt="" />
    <span className="brand-logo__name"><strong>乐学</strong>{!wordmark && <small>Welearn</small>}</span>
    <span className="brand-logo__portal">{portal}</span>
  </span>
}
